import { render, staticRenderFns } from "./EditUserProfileForm.vue?vue&type=template&id=527c3f01&scoped=true&"
import script from "./EditUserProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditUserProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfileForm.vue?vue&type=style&index=0&id=527c3f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c3f01",
  null
  
)

export default component.exports